const STORAGE_KEY = "zenfresh_cookie_consent_v1";

export interface CookiePreferences {
  essential: true;
  analytics: boolean;
  marketing: boolean;
}

export const DEFAULT_PREFERENCES: CookiePreferences = {
  essential: true,
  analytics: false,
  marketing: false,
};

export function readConsent(): CookiePreferences | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CookiePreferences>;
    return { essential: true, analytics: !!parsed.analytics, marketing: !!parsed.marketing };
  } catch {
    return null;
  }
}

export function writeConsent(preferences: CookiePreferences) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
  } catch {
    // Storage unavailable (private browsing, quota, etc.) — consent simply
    // won't persist across visits; not worth surfacing an error for.
  }
}

export function hasAnalyticsConsent(): boolean {
  return readConsent()?.analytics === true;
}
